export const getOptionById = (filter, value) => {
    if (filter && filter.options) {
        return filter.options.find((option) => option.id === value);
    }
};
